import getAppliedGiftcards from '../selectors/GiftCardSelectors/getAppliedGiftcards';
import {getSelectedPaymentOptionType, isCreditUsed} from '../selectors/selectors';
import getProductIdForGTM from './getProductIdForGTM';
import getCategoriesFromProduct from './getCategoriesFromProduct';
import getProductVariantIdForGTM from './getProductVariantIdForGTM';

export default (getState) => {
  if (!window.dataLayer?.push) {
    return 'fail';
  }
  
  const {start} = window;
  const {order} = start;
  
  const paymentTypeUsed = getSelectedPaymentOptionType(getState);
  const hasUsedAccountCredit = isCreditUsed(getState);
  const hasAppliedGiftcards = getAppliedGiftcards(getState).length > 0;
  
  window.dataLayer.push({
    event: 'add_payment_info',
    ecommerce: {
      currency: start.orderTotal?.currencyCode || '',
      value: start.orderTotal?.value,
      coupon: order?.discountCode || '',
      payment_type: paymentTypeUsed,
      account_credit_used: hasUsedAccountCredit,
      gift_card_used: hasAppliedGiftcards,
      items: order.basketItems?.map(basketItem => ({
        item_id: getProductIdForGTM(basketItem),
        ...getCategoriesFromProduct(basketItem),
        item_name: basketItem?.productTitle,
        item_brand: basketItem?.brand,
        item_variant: getProductVariantIdForGTM(basketItem),
        price: basketItem?.chargePricePerUnit?.value,
        quantity: basketItem?.quantity,
      })),
    },
  });
  return 'success';
};
